import { createSlice } from '@reduxjs/toolkit';
import { loadPrograms } from './programs.middleware';
import { logout } from '../auth/auth-middleware';

export type Program = {
    value: string;
    label: string;
    display_color?: string;
};

type State = {
    list: Program[];
    error: string | null;
    isLoading: boolean;
    // Cache key to track what we've loaded: "userId:country"
    lastLoadedKey: string | null;
};

const initialState: State = {
    list: [],
    error: null,
    isLoading: false,
    lastLoadedKey: null,
};

export const programsSlice = createSlice({
    name: 'app/programs',
    initialState,
    reducers: {
        clearPrograms: (state) => {
            state.list = [];
            state.error = null;
            state.lastLoadedKey = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadPrograms.fulfilled, (state, action) => {
                state.list = action.payload.programs;
                state.lastLoadedKey = action.payload.cacheKey;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(loadPrograms.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(loadPrograms.rejected, (state, action) => {
                state.error = action.payload as string;
                state.isLoading = false;
            })
            .addCase(logout.fulfilled, (state) => {
                state.list = [];
                state.error = null;
                state.isLoading = false;
                state.lastLoadedKey = null;
            });
    },
});

export const { clearPrograms } = programsSlice.actions;
export default programsSlice.reducer;
